import { styled } from '@mui/material';
import { Grid } from '@mui/system';

const StyledDivRoot = styled(Grid)({ padding: '1rem' });

const StyledGrid = styled(Grid)({ padding: '5px' });

const SpacedContainer = styled(Grid)({ padding: '1rem' });

const StyledTypography = styled('h3')({});

export { StyledDivRoot, StyledTypography, SpacedContainer, StyledGrid };
